export default "__VITE_ASSET__CKdfCaWl__"